import { getModuleNameDisplayText, getRecommendedModule, getChildVsChildren, } from '../helpers/utilities';
export const variableFunctions = {
    spouseTerm: (data) => {
        const term = data.user.Global.spouseType;
        if (term === 'Spouse') {
            return 'spouse';
        }
        else if (term === 'SSDP') {
            return 'partner';
        }
        return null;
    },
    childTerm: (data) => {
        const numKids = data.user.Global.numKids;
        return getChildVsChildren(numKids);
    },
    recommendedModule: recommendedModule,
    recommendedModuleDisplayText: (data) => {
        return getModuleNameDisplayText(data.modules, recommendedModule(data));
    },
};
export function recommendedModule(data) {
    return getRecommendedModule(data.user);
}
//# sourceMappingURL=global.js.map